export const colors = {
  black: "#2c2e2d",
};
